var _path, _g, _path2, _g2, _g3, _circle, _circle2, _rect, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 106,
    viewBox: "0 0 146 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.12037 32.1685C4.34674 48.7512 15.9415 51.3802 17.9579 78.2765C19.5711 99.7127 34.493 105.375 43.0631 105.982C47.096 106.285 62.0179 102.847 59.3965 91.5225C50.7257 52.998 81.4769 12.6534 43.4664 2.54203C28.0403 -1.60365 -6.34059 -5.44599 1.01955 32.1685H1.12037Z",
    fill: "#B198F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1201_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.699 25H31.3015C27.269 25 24 28.2871 24 32.3419V85.6581C24 89.7129 27.269 93 31.3015 93H127.699C131.731 93 135 89.7129 135 85.6581V32.3419C135 28.2871 131.731 25 127.699 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.699 22.5H31.3015C25.8753 22.5 21.5 26.9194 21.5 32.3419V85.6581C21.5 91.0806 25.8753 95.5 31.3015 95.5H127.699C133.125 95.5 137.5 91.0806 137.5 85.6581V32.3419C137.5 26.9194 133.125 22.5 127.699 22.5Z",
    stroke: "#B397F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1201_1118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 20,
    width: 121,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.699 22.5H31.3015C25.8753 22.5 21.5 26.9194 21.5 32.3419V85.6581C21.5 91.0806 25.8753 95.5 31.3015 95.5H127.699C133.125 95.5 137.5 91.0806 137.5 85.6581V32.3419C137.5 26.9194 133.125 22.5 127.699 22.5Z",
    fill: "white",
    stroke: "#B397F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1201_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1201_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0001 40C88.0585 40 94.5913 46.4919 94.5913 54.5C94.5913 62.5081 88.0585 69 80.0001 69C71.9416 69 65.4089 62.5081 65.4089 54.5C65.4089 46.4919 71.9416 40 80.0001 40ZM90.9435 72.625H88.3535C83.1757 74.991 77.0476 75.0932 71.6466 72.625H69.0567C63.0127 72.625 58.1133 77.4938 58.1133 83.5V114.312C58.1133 117.316 60.563 119.75 63.585 119.75H67.2328V150.562C67.2328 153.566 69.6825 156 72.7045 156H87.2957C90.3176 156 92.7674 153.566 92.7674 150.562V119.75H96.4152C99.4371 119.75 101.887 117.316 101.887 114.312V83.5C101.887 77.4938 96.9874 72.625 90.9435 72.625Z",
    fill: "#EDE1FF"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1201_1118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 24.5,
    r: 10.5,
    fill: "#EB9500"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 24.5,
    r: 5.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 20.5,
    r: 3.5,
    fill: "#EB9500"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 93,
    width: 50,
    height: 5,
    fill: "#B397F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8091 6.53196C84.1652 0.488242 73.8321 0.490455 67.1908 6.53196C66.9411 6.75914 66.9362 7.14381 67.1777 7.37948L68.4617 8.63234C68.692 8.85731 69.0625 8.86211 69.3017 8.64635C74.7737 3.71608 83.2255 3.71497 88.6986 8.64635C88.9379 8.86211 89.3084 8.85694 89.5386 8.63234L90.8226 7.37948C91.0637 7.14381 91.0589 6.75914 90.8091 6.53196ZM86.6001 10.7191C82.2779 6.95978 75.7172 6.96383 71.3998 10.7191C71.1411 10.944 71.1328 11.3346 71.3785 11.5729L72.67 12.8265C72.895 13.0448 73.2572 13.0596 73.4968 12.856C76.645 10.1795 81.3621 10.1854 84.5027 12.856C84.7424 13.0596 85.1046 13.0452 85.3296 12.8265L86.6211 11.5729C86.8671 11.3346 86.8585 10.9437 86.6001 10.7191Z",
    fill: "#EB9500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1201_1118",
    x: 13,
    y: 14,
    width: 133,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0666667 0 0 0 0 0.309804 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1201_1118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1201_1118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1201_1118",
    x: 63,
    y: 8,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0666667 0 0 0 0 0.309804 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1201_1118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1201_1118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1201_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7736,
    height: 116,
    fill: "white",
    transform: "translate(58.1133 40)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.36836cd86f90d3aabed5cd233067bcb4.svg";
export { ForwardRef as ReactComponent };